import { useRouter } from "next/router";

import { hasTranslation } from "@/lib/i18n/content";
import { useLocale, useStrings } from "@/lib/i18n/context";
import { ALL_LOCALES, LOCALE_META, localizedPath, stripLocale } from "@/lib/i18n/locales";

const LanguageSwitcher = () => {
  const router = useRouter();
  const locale = useLocale();
  const s = useStrings();
  const path = stripLocale(router.asPath || "/");
  const available = ALL_LOCALES.filter((candidate) => hasTranslation(candidate, path));

  if (available.length < 2) return null;

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 pt-6 text-[13px] text-gray-700">
      <span className="text-gray-500">{s.footer.language}:</span>
      {available.map((candidate) =>
        candidate === locale ? (
          <span key={candidate} className="font-medium text-gray-900">
            {LOCALE_META[candidate].label}
          </span>
        ) : (
          <a
            key={candidate}
            href={localizedPath(candidate, path)}
            hrefLang={LOCALE_META[candidate].htmlLang}
            className="hover:text-gray-900"
          >
            {LOCALE_META[candidate].label}
          </a>
        ),
      )}
    </div>
  );
};

export default LanguageSwitcher;
